import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import Footer from "../Core/Footer";
import Header from "../Core/Header";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/slices/authSlice";
import { useNavigate } from "react-router-dom";
import {
  bookigHistory,
  editProfile,
  getProfile,
  logoutUser,
} from "../../service/operations/api_methods";
import { toast } from "sonner";
import { details } from "motion/react-client";
import { useMediaQuery } from "usehooks-ts";

const MyProfile = () => {
  const [state, setState] = useState("myprofile");

  const mobile = useMediaQuery("(max-width: 767px)");

  const token =
    useSelector((state) => state.auth.token) || Cookies.get("roam-token");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [editMode, setEditMode] = useState(false);
  const [bookingType, setbookingType] = useState(1);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [balance, setBalance] = useState("");

  const [history, setHistory] = useState([]);
  const [cancellations, setCancellations] = useState([]);

  const handleLogout = async () => {
    try {
      const response = await logoutUser({ phone, token });
      console.log("edited", response);
      if (response.status === 200) {
        setEditMode(false);
      }

      dispatch(logout());
      navigate("/");
    } catch (error) {
      console.log(error);
    }
  };

  const handleEditProfile = async () => {
    try {
      let data = {
        name: name,
        email: email,
        phone: phone,
      };

      const response = await editProfile({ data, token });
      console.log("edited", response);
      if (response.status === 200) {
        setEditMode(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const handleGetProfile = async () => {
      try {
        const response = await getProfile(token);
        console.log("profile", response);
        if (response.status === 200) {
          setName(response.data.user.name);
          setEmail(response.data.user.email);
          setPhone(response.data.user.phone);
          setBalance(response.data.user.walletBalance);
        }
      } catch (error) {
        console.log(error);
      }
    };

    const handleGetBookingHistory = async () => {
      try {
        const response = await bookigHistory(token);
        console.log(response);
        if (response.status === 200) {
          setHistory(response.data.bookings);
        }
      } catch (error) {
        console.log(error);
      }
    };

    handleGetProfile();
    handleGetBookingHistory();
  }, []);

  const truncateText = (text, maxLength) => {
    if (!text) return "";
    if (text.length <= maxLength) {
      return text;
    }
    return `${text.substring(0, maxLength)}...`;
  };

  return (
    <>
      <div style={{ backgroundColor: "white" }}>
        <Header />
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: mobile ? "column" : "row",
          justifyContent: "space-between",
          height: "100vh",
          maxHeight: "fit-content",
        }}
      >
        {mobile ? (
          <div
            style={{
              backgroundColor: "#c4c2c2ff",
              height: "10vh",
              width: mobile ? "100%" : "15%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "5px",
            }}
          >
            {mobile ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: mobile ? "column" : "row",
                  gap: "5px",
                  padding: "10px",
                  alignItems: "start",
                }}
              >
                <div
                  style={{
                    objectFit: "cover",
                    borderRadius: "50%",
                    width: "20px",
                    height: "20px",
                    backgroundColor: "white",
                    textAlign: "center",
                  }}
                >
                  <img
                    src="/Assets/user.png"
                    style={{ width: "20px", height: "20px" }}
                  />
                </div>
                <div>
                  <p style={{ fontSize: "10px", fontWeight: "700" }}>{name}</p>
                  <p style={{ fontSize: "8px", fontWeight: "400" }}>{email}</p>
                </div>
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: mobile ? "column" : "row",
                  gap: "20px",
                  padding: "20px",
                  alignItems: "center",
                  borderBottom: "1px solid black",
                }}
              >
                <div
                  style={{
                    objectFit: "cover",
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    backgroundColor: "white",
                    textAlign: "center",
                  }}
                >
                  <img
                    src="/Assets/user.png"
                    style={{ width: "40px", height: "40px" }}
                  />
                </div>
                <div style={{ overflow: "hidden" }}>
                  <p style={{ fontSize: "14px", fontWeight: "700" }}>
                    {truncateText(name, 20)}
                  </p>
                  {/* <p style={{fontSize:"10px",fontWeight:"400",overflow:"hidden",width:"100px"}}>{truncateText(email,20)}</p> */}
                </div>
              </div>
            )}

            <div style={{ display: "flex", gap: "5px" }}>
              <div
                onClick={() => setState("mytravel")}
                style={{
                  padding: "8px",
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  cursor: "pointer",
                  backgroundColor:
                    state === "mytravel" ? "white" : "transparent",
                }}
              >
                <img
                  src="/Assets/bus-icon.png"
                  style={{ width: "15px", height: "15px" }}
                />
                <span style={{ fontWeight: "600" }}> My Trips</span>
              </div>

              <div
                onClick={() => setState("myprofile")}
                style={{
                  padding: "8px",
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  cursor: "pointer",
                  backgroundColor:
                    state === "myprofile" ? "white" : "transparent",
                }}
              >
                <img
                  src="/Assets/account.png"
                  style={{ width: "12px", height: "12px" }}
                />
                <span style={{ fontWeight: "600" }}>My Profile</span>
              </div>
            </div>
          </div>
        ) : (
          <div
            style={{
              backgroundColor: "#c4c2c2ff",
              height: "100%",
              width: mobile ? "100%" : "15%",
              overflow: "hidden",
            }}
          >
            {!mobile && (
              <p
                style={{ fontSize: "25px", fontWeight: "700", padding: "20px" }}
              >
                My Account
              </p>
            )}

            {mobile ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: mobile ? "column" : "row",
                  gap: "10px",
                  padding: "10px",
                  alignItems: "center",
                  borderBottom: "1px solid black",
                }}
              >
                <div
                  style={{
                    objectFit: "cover",
                    borderRadius: "50%",
                    width: "20px",
                    height: "20px",
                    backgroundColor: "white",
                    textAlign: "center",
                  }}
                >
                  <img
                    src="/Assets/user.png"
                    style={{ width: "20px", height: "20px" }}
                  />
                </div>
                <div>
                  <p style={{ fontSize: "14px", fontWeight: "700" }}>{name}</p>
                  <p style={{ fontSize: "10px", fontWeight: "400" }}>{email}</p>
                </div>
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: mobile ? "column" : "row",
                  gap: "20px",
                  padding: "20px",
                  alignItems: "center",
                  borderBottom: "1px solid black",
                }}
              >
                <div
                  style={{
                    objectFit: "cover",
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    backgroundColor: "white",
                    textAlign: "center",
                  }}
                >
                  <img
                    src="/Assets/user.png"
                    style={{ width: "40px", height: "40px" }}
                  />
                </div>
                <div>
                  <p style={{ fontSize: "14px", fontWeight: "700" }}>{name}</p>
                  <p style={{ fontSize: "10px", fontWeight: "400" }}>
                    {truncateText(email, 20)}
                  </p>
                </div>
              </div>
            )}

            <div
              onClick={() => navigate("/")}
              style={{
                padding: "20px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                cursor: "pointer",
                backgroundColor: state === "mytrave" ? "white" : "transparent",
              }}
            >
              <img
                src="/Assets/bus-icon.png"
                style={{ width: "25px", height: "25px" }}
              />
              <span style={{ fontWeight: "600" }}> Search buses</span>
            </div>

            <div
              onClick={() => setState("myprofile")}
              style={{
                padding: "20px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                cursor: "pointer",
                backgroundColor:
                  state === "myprofile" ? "white" : "transparent",
              }}
            >
              <img
                src="/Assets/account.png"
                style={{ width: "25px", height: "25px" }}
              />
              <span style={{ fontWeight: "600" }}>My Profile</span>
            </div>

            <div
              onClick={() => setState("mytravel")}
              style={{
                padding: "20px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                cursor: "pointer",
                backgroundColor: state === "mytravel" ? "white" : "transparent",
              }}
            >
              <img
                src="/Assets/bus-icon.png"
                style={{ width: "25px", height: "25px" }}
              />
              <span style={{ fontWeight: "600" }}> My Trips</span>
            </div>
          </div>
        )}

        {mobile ? (
          <div style={{ width: "100vw", height: "100%" }}>
            {state === "myprofile" ? (
              <div
                style={{
                  padding: "10px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <p style={{ fontSize: "20px", fontWeight: "700" }}>
                  Account Setting
                </p>

                <div
                  style={{
                    boxShadow: "0 0 10px 2px rgba(94, 36, 36, 0.3)",
                    width: "100%",
                    height: "fit-content",
                    borderRadius: "10px",
                    padding: "5px",
                  }}
                >
                  <p style={{ fontSize: "14px", fontWeight: "700" }}>Profile</p>
                  <div
                    style={{
                      width: "90%",
                      height: "70%",
                      borderRadius: "10px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "20px",
                      paddingTop: "10px",
                    }}
                  >
                    <div style={{}}>
                      <div
                        style={{
                          objectFit: "cover",
                          borderRadius: "50%",
                          width: "50px",
                          height: "50px",
                          backgroundColor: "white",
                          textAlign: "center",
                        }}
                      >
                        <img
                          src="/Assets/user.png"
                          style={{ width: "50px", height: "50px" }}
                        />
                      </div>
                      <p
                        style={{
                          padding: "3px",
                          border: "0.2px solid gray",
                          fontSize: "10px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          color: "#036b94ff",
                          width: "60px",
                        }}
                      >
                        Change
                      </p>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        paddingBottom: "10px",
                      }}
                    >
                      <p
                        style={{
                          fontWeight: "700",
                          display: "flex",
                          gap: "10px",
                          width: "90%",
                          justifyContent: "space-between",
                        }}
                      >
                        <span style={{ fontSize: "14px", color: "gray" }}>
                          Name
                        </span>
                        {!editMode ? (
                          <span
                            style={{
                              fontSize: "14px",
                              padding: "5px",
                              borderBottom: "0.3px solid gray",
                              width: "300px",
                            }}
                          >
                            {name}
                          </span>
                        ) : (
                          <input
                            value={name}
                            style={{
                              fontSize: "14px",
                              padding: "5px",
                              borderBottom: "0.3px solid gray",
                              width: "300px",
                            }}
                            onChange={(e) => setName(e.target.value)}
                          />
                        )}
                      </p>

                      {/* <p style={{fontWeight:"700",display:"flex",gap:"10px",width:"90%",justifyContent:"space-between"}}><span style={{fontSize:"14px",color:"gray"}}>Dob</span>
                <span style={{fontSize:"14px",padding:"5px",borderBottom:"0.3px solid gray",width:"300px"}}> 20-08-2002</span></p> */}

                      <p
                        style={{
                          fontWeight: "700",
                          display: "flex",
                          gap: "10px",
                          width: "90%",
                          justifyContent: "space-between",
                        }}
                      >
                        <span style={{ fontSize: "14px", color: "gray" }}>
                          Email{" "}
                        </span>
                        {!editMode ? (
                          <span
                            style={{
                              fontSize: "14px",
                              padding: "5px",
                              borderBottom: "0.3px solid gray",
                              width: "300px",
                            }}
                          >
                            {email}
                          </span>
                        ) : (
                          <input
                            value={email}
                            style={{
                              fontSize: "14px",
                              padding: "5px",
                              borderBottom: "0.3px solid gray",
                              width: "300px",
                            }}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        )}
                      </p>

                      <p
                        style={{
                          fontWeight: "700",
                          display: "flex",
                          gap: "10px",
                          width: "90%",
                          justifyContent: "space-between",
                        }}
                      >
                        <span style={{ fontSize: "14px", color: "gray" }}>
                          Phone{" "}
                        </span>
                        {!editMode ? (
                          <span
                            style={{
                              fontSize: "14px",
                              padding: "5px",
                              borderBottom: "0.3px solid gray",
                              width: "300px",
                            }}
                          >
                            {" "}
                            {phone}
                          </span>
                        ) : (
                          <input
                            value={phone}
                            style={{
                              fontSize: "14px",
                              padding: "5px",
                              borderBottom: "0.3px solid gray",
                              width: "300px",
                            }}
                            onChange={(e) => setPhone(e.targetvalue)}
                          />
                        )}
                      </p>
                      <p
                        style={{
                          fontWeight: "700",
                          display: "flex",
                          gap: "20px",
                          width: "90%",
                          justifyContent: "space-between",
                        }}
                      >
                        <span style={{ fontSize: "14px", color: "gray" }}>
                          Wallet Balance{" "}
                        </span>
                        {!editMode ? (
                          <span
                            style={{
                              fontSize: "14px",
                              padding: "5px",
                              borderBottom: "0.3px solid gray",
                              width: "400px",
                            }}
                          >
                            {" "}
                            {balance}
                          </span>
                        ) : (
                          <input
                            value={balance}
                            style={{
                              fontSize: "14px",
                              padding: "5px",
                              borderBottom: "0.3px solid gray",
                              width: "400px",
                            }}
                            onChange={(e) => setBalance(e.target.balance)}
                          />
                        )}
                      </p>

                      {editMode ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-around",
                          }}
                        >
                          <p
                            onClick={() => setEditMode(false)}
                            style={{
                              fontWeight: "600",
                              padding: "6px",
                              borderRadius: "8px",
                              backgroundColor: "#2dc1fcff",
                              cursor: "pointer",
                              width: "fit-content",
                              marginTop: "30px",
                              color: "white",
                            }}
                          >
                            cancel
                          </p>
                          <p
                            style={{
                              fontWeight: "600",
                              padding: "6px",
                              borderRadius: "8px",
                              backgroundColor: "#f73e4eff",
                              cursor: "pointer",
                              width: "fit-content",
                              marginTop: "30px",
                              color: "white",
                            }}
                            onClick={handleEditProfile}
                          >
                            Update
                          </p>
                        </div>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-around",
                          }}
                        >
                          <p
                            onClick={() => setEditMode(true)}
                            style={{
                              fontWeight: "600",
                              padding: "6px",
                              borderRadius: "8px",
                              backgroundColor: "#2dc1fcff",
                              cursor: "pointer",
                              width: "fit-content",
                              marginTop: "30px",
                              color: "white",
                            }}
                          >
                            Change
                          </p>
                          <p
                            style={{
                              fontWeight: "600",
                              padding: "6px",
                              borderRadius: "8px",
                              backgroundColor: "#f73e4eff",
                              cursor: "pointer",
                              width: "fit-content",
                              marginTop: "30px",
                              color: "white",
                            }}
                            onClick={handleLogout}
                          >
                            Logout
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div
                style={{
                  padding: "10px",
                  paddingLeft: "10px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                <p
                  style={{
                    fontSize: "15px",
                    fontWeight: "600",
                    display: "flex",
                    gap: "16px",
                    cursor: "pointer",
                  }}
                >
                  <span
                    onClick={() => setbookingType(1)}
                    style={{
                      padding: "6px",
                      borderRadius: "4px",
                      border: "0.3px solid grey",
                      color: bookingType === 1 ? "white" : "black",
                      backgroundColor: bookingType === 1 ? "#144c94" : "white",
                    }}
                  >
                    My Bookings
                  </span>
                  <span
                    onClick={() => setbookingType(2)}
                    style={{
                      padding: "6px",
                      borderRadius: "4px",
                      border: "0.3px solid grey",
                      color: bookingType === 2 ? "white" : "black",
                      backgroundColor: bookingType === 2 ? "#144c94" : "white",
                    }}
                  >
                    Cancellations
                  </span>{" "}
                </p>
                <div style={{ display: "flex", gap: "16px" }}>
                  <div
                    style={{
                      boxShadow: "0 4px 8px rgba(94, 36, 36, 0.2)",
                      width: "100%",
                      height: "100%",
                      borderRadius: "10px",
                      padding: "20px",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "18px",
                        fontWeight: "700",
                        padding: "10px",
                      }}
                    >
                      Previous Trips
                    </p>
                    {bookingType === 1 ? (
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          flexDirection: "column",
                          padding: "10px",
                          maxHeight: "70vh",
                          overflow: "auto",
                        }}
                      >
                        {history.map((deatil) => {
                          let d = deatil;
                          if (deatil.tripType === "roundTrip") {
                            d = deatil.bookings[0];
                          }
                          return (
                            <div
                              style={{
                                padding: "14px",
                                position: "relative",
                                boxShadow: "0px 0px 15px rgba(63, 24, 24, 0.4)",
                                display: "flex",
                                flexDirection: "column",
                                gap: "14px",
                                borderRadius: "10px",
                              }}
                            >
                              <p
                                style={{
                                  cursor: "pointer",
                                  position: "absolute",
                                  right: "6px",
                                  padding: "5px",
                                  borderRadius: "10px",
                                  backgroundColor: "#23b6aaff",
                                  color: "white",
                                }}
                                onClick={() => navigate("/ticket/" + d.id)}
                              >
                                View ticket
                              </p>
                              <img
                                src="/Assets/bus_10.png"
                                style={{ width: "45px" }}
                              />
                              <p
                                style={{ fontSize: "16px", fontWeight: "700" }}
                              >
                                {d.boardingPoint?.name}
                                <span
                                  style={{
                                    margin: "0px 20px",
                                    fontSize: "12px",
                                  }}
                                >
                                  {deatil.tripType === "roundTrip" ? (
                                    <img
                                      src="/Assets/switch.png"
                                      style={{ width: "20px" }}
                                    />
                                  ) : (
                                    <span> To </span>
                                  )}
                                </span>
                                {d.droppingPoint?.name}
                              </p>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <p
                                  style={{
                                    fontSize: "16px",
                                    fontWeight: "500",
                                  }}
                                >
                                  <img
                                    src="/Assets/date.png"
                                    style={{ width: "15px" }}
                                  />
                                  {new Date(
                                    d.journeyDetails?.date,
                                  ).toLocaleDateString()}
                                  {"  "}
                                </p>
                                <p
                                  style={{
                                    fontSize: "16px",
                                    fontWeight: "500",
                                    margin: "0px 20px",
                                  }}
                                >
                                  <span>
                                    <img
                                      src="/Assets/ticket-10.png"
                                      style={{ width: "15px" }}
                                    />{" "}
                                    {d.pricing?.payableAmount} /-
                                  </span>
                                  <span
                                    style={{
                                      borderRadius: "15px",
                                      padding: "4px",
                                      backgroundColor:
                                        d?.paymentStatus !== "success"
                                          ? "#666666ff"
                                          : "#33b966ff",
                                      color: "white",
                                    }}
                                  >
                                    {d.paymentStatus}
                                  </span>
                                </p>
                              </div>

                              <p
                                style={{
                                  borderBottom: "1px solid gray",
                                  fontSize: "17px",
                                  fontWeight: "600",
                                  color: "#1674aa",
                                }}
                              >
                                Passengers
                              </p>
                              {d?.seats?.map((i) => (
                                <p
                                  style={{
                                    padding: "8px",
                                    backgroundColor: "rgb(224, 222, 222)",
                                    borderRadius: "6px",
                                    margin: "4px",
                                  }}
                                >
                                  Seat No :
                                  <span style={{ fontWeight: "700" }}>
                                    {" "}
                                    {i.seatNumber}
                                  </span>
                                  <span
                                    style={{
                                      paddingLeft: "20px",
                                      fontSize: "17px",
                                      fontWeight: 700,
                                    }}
                                  >
                                    {i.passenger.name}({i.passenger.gender})
                                  </span>
                                  <span style={{ paddingLeft: "17px" }}>
                                    Seat Price : {i.fare}
                                  </span>
                                </p>
                              ))}

                              <p>
                                {" "}
                                Booking created At :
                                {new Date(deatil.createdAt).toLocaleString(
                                  "en-IN",
                                  {
                                    timeZone: "Asia/Kolkata",
                                  },
                                )}
                                {}
                              </p>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          flexDirection: "column",
                          padding: "10px",
                          maxHeight: "70vh",
                          overflow: "auto",
                        }}
                      >
                        {cancellations.map((deatil) => {
                          let d = deatil;
                          if (deatil.tripType === "roundTrip") {
                            d = deatil.bookings[0];
                          }
                          return (
                            <div
                              style={{
                                padding: "14px",
                                position: "relative",
                                boxShadow: "0px 0px 15px rgba(63, 24, 24, 0.4)",
                                display: "flex",
                                flexDirection: "column",
                                gap: "14px",
                                borderRadius: "10px",
                              }}
                            >
                              <p
                                style={{
                                  cursor: "pointer",
                                  position: "absolute",
                                  right: "6px",
                                  padding: "5px",
                                  borderRadius: "10px",
                                  backgroundColor: "#23b6aaff",
                                  color: "white",
                                }}
                                onClick={() => navigate("/ticket/" + d.id)}
                              >
                                View ticket
                              </p>
                              <img
                                src="/Assets/bus_10.png"
                                style={{ width: "45px" }}
                              />
                              <p
                                style={{ fontSize: "16px", fontWeight: "700" }}
                              >
                                {d.boardingPoint?.name}
                                <span
                                  style={{
                                    margin: "0px 20px",
                                    fontSize: "12px",
                                  }}
                                >
                                  {deatil.tripType === "roundTrip" ? (
                                    <img
                                      src="/Assets/switch.png"
                                      style={{ width: "20px" }}
                                    />
                                  ) : (
                                    <span> To </span>
                                  )}
                                </span>
                                {d.droppingPoint?.name}
                              </p>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <p
                                  style={{
                                    fontSize: "16px",
                                    fontWeight: "500",
                                  }}
                                >
                                  <img
                                    src="/Assets/date.png"
                                    style={{ width: "15px" }}
                                  />
                                  {new Date(
                                    d.journeyDetails?.date,
                                  ).toLocaleDateString()}
                                  {"  "}
                                </p>
                                <p
                                  style={{
                                    fontSize: "16px",
                                    fontWeight: "500",
                                    margin: "0px 20px",
                                  }}
                                >
                                  <span>
                                    <img
                                      src="/Assets/ticket-10.png"
                                      style={{ width: "15px" }}
                                    />{" "}
                                    {d.pricing?.payableAmount} /-
                                  </span>
                                  <span
                                    style={{
                                      borderRadius: "15px",
                                      padding: "4px",
                                      backgroundColor:
                                        d?.paymentStatus !== "success"
                                          ? "#666666ff"
                                          : "#33b966ff",
                                      color: "white",
                                    }}
                                  >
                                    {d.paymentStatus}
                                  </span>
                                </p>
                              </div>

                              <p
                                style={{
                                  borderBottom: "1px solid gray",
                                  fontSize: "17px",
                                  fontWeight: "600",
                                  color: "#1674aa",
                                }}
                              >
                                Passengers
                              </p>
                              {d?.seats?.map((i) => (
                                <p
                                  style={{
                                    padding: "8px",
                                    backgroundColor: "rgb(224, 222, 222)",
                                    borderRadius: "6px",
                                    margin: "4px",
                                  }}
                                >
                                  Seat No :
                                  <span style={{ fontWeight: "700" }}>
                                    {" "}
                                    {i.seatNumber}
                                  </span>
                                  <span
                                    style={{
                                      paddingLeft: "20px",
                                      fontSize: "17px",
                                      fontWeight: 700,
                                    }}
                                  >
                                    {i.passenger.name}({i.passenger.gender})
                                  </span>
                                  <span style={{ paddingLeft: "17px" }}>
                                    Seat Price : {i.fare}
                                  </span>
                                </p>
                              ))}

                              <p>
                                {" "}
                                Booking created At :
                                {new Date(deatil.createdAt).toLocaleString(
                                  "en-IN",
                                  {
                                    timeZone: "Asia/Kolkata",
                                  },
                                )}
                                {}
                              </p>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div style={{ width: "85%", height: "100%" }}>
            {state === "myprofile" ? (
              <div
                style={{
                  padding: "50px",
                  paddingLeft: "100px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                <p style={{ fontSize: "30px", fontWeight: "700" }}>
                  Account Setting
                </p>

                <div
                  style={{
                    boxShadow: "0 0 10px 2px rgba(94, 36, 36, 0.3)",
                    width: "100%",
                    height: "fit-content",
                    borderRadius: "10px",
                    padding: "20px",
                    overflow: "hidden",
                  }}
                >
                  <p style={{ fontSize: "20px", fontWeight: "700" }}>Profile</p>
                  <div
                    style={{
                      width: "90%",
                      height: "70%",
                      borderRadius: "10px",
                      display: "flex",
                      gap: "60px",
                      paddingTop: "30px",
                    }}
                  >
                    <div style={{}}>
                      <div
                        style={{
                          objectFit: "cover",
                          borderRadius: "50%",
                          width: "120px",
                          height: "120px",
                          backgroundColor: "white",
                          textAlign: "center",
                        }}
                      >
                        <img
                          src="/Assets/user.png"
                          style={{ width: "120px", height: "120px" }}
                        />
                      </div>
                     
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "30px",
                        paddingBottom: "30px",
                      }}
                    >
                      <p
                        style={{
                          fontWeight: "700",
                          display: "flex",
                          gap: "20px",
                          width: "90%",
                          justifyContent: "space-between",
                        }}
                      >
                        <span style={{ fontSize: "20px", color: "gray" }}>
                          Name
                        </span>
                        {!editMode ? (
                          <span
                            style={{
                              fontSize: "14px",
                              padding: "5px",
                              borderBottom: "0.3px solid gray",
                              width: "400px",
                            }}
                          >
                            {name}
                          </span>
                        ) : (
                          <input
                            value={name}
                            style={{
                              fontSize: "14px",
                              padding: "5px",
                              borderBottom: "0.3px solid gray",
                              width: "400px",
                            }}
                            onChange={(e) => setName(e.target.value)}
                          />
                        )}
                      </p>

                      {/* <p style={{fontWeight:"700",display:"flex",gap:"20px",width:"90%",justifyContent:"space-between"}}><span style={{fontSize:"20px",color:"gray"}}>Dob</span>
                <span style={{fontSize:"14px",padding:"5px",borderBottom:"0.3px solid gray",width:"400px"}}> 20-08-2002</span></p> */}
                      <p
                        style={{
                          fontWeight: "700",
                          display: "flex",
                          gap: "20px",
                          width: "90%",
                          justifyContent: "space-between",
                        }}
                      >
                        <span style={{ fontSize: "20px", color: "gray" }}>
                          Email{" "}
                        </span>
                        {!editMode ? (
                          <span
                            style={{
                              fontSize: "14px",
                              padding: "5px",
                              borderBottom: "0.3px solid gray",
                              width: "400px",
                            }}
                          >
                            {email}
                          </span>
                        ) : (
                          <input
                            value={email}
                            style={{
                              fontSize: "14px",
                              padding: "5px",
                              borderBottom: "0.3px solid gray",
                              width: "400px",
                            }}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        )}
                      </p>

                      <p
                        style={{
                          fontWeight: "700",
                          display: "flex",
                          gap: "20px",
                          width: "90%",
                          justifyContent: "space-between",
                        }}
                      >
                        <span style={{ fontSize: "20px", color: "gray" }}>
                          Phone{" "}
                        </span>
                        {!editMode ? (
                          <span
                            style={{
                              fontSize: "14px",
                              padding: "5px",
                              borderBottom: "0.3px solid gray",
                              width: "400px",
                            }}
                          >
                            {" "}
                            {phone}
                          </span>
                        ) : (
                          <input
                            value={phone}
                            style={{
                              fontSize: "14px",
                              padding: "5px",
                              borderBottom: "0.3px solid gray",
                              width: "400px",
                            }}
                            onChange={(e) => setPhone(e.targetvalue)}
                          />
                        )}
                      </p>
                      <p
                        style={{
                          fontWeight: "700",
                          display: "flex",
                          gap: "20px",
                          width: "90%",
                          justifyContent: "space-between",
                        }}
                      >
                        <span style={{ fontSize: "14px", color: "gray" }}>
                          Wallet Balance{" "}
                        </span>
                        {!editMode ? (
                          <span
                            style={{
                              fontSize: "14px",
                              padding: "5px",
                              borderBottom: "0.3px solid gray",
                              width: "400px",
                            }}
                          >
                            {" "}
                            {balance}
                          </span>
                        ) : (
                          <input
                            value={balance}
                            style={{
                              fontSize: "14px",
                              padding: "5px",
                              borderBottom: "0.3px solid gray",
                              width: "400px",
                            }}
                            onChange={(e) => setBalance(e.target.balance)}
                          />
                        )}
                      </p>

                      {editMode ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-around",
                          }}
                        >
                          <p
                            onClick={() => setEditMode(false)}
                            style={{
                              fontWeight: "600",
                              padding: "6px",
                              borderRadius: "8px",
                              backgroundColor: "#2dc1fcff",
                              cursor: "pointer",
                              width: "fit-content",
                              marginTop: "30px",
                              color: "white",
                            }}
                          >
                            cancel
                          </p>
                          <p
                            style={{
                              fontWeight: "600",
                              padding: "6px",
                              borderRadius: "8px",
                              backgroundColor: "#f73e4eff",
                              cursor: "pointer",
                              width: "fit-content",
                              marginTop: "30px",
                              color: "white",
                            }}
                            onClick={handleEditProfile}
                          >
                            Update
                          </p>
                        </div>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-around",
                          }}
                        >
                          <p
                            onClick={() => setEditMode(true)}
                            style={{
                              fontWeight: "600",
                              padding: "6px",
                              borderRadius: "8px",
                              backgroundColor: "#2dc1fcff",
                              cursor: "pointer",
                              width: "fit-content",
                              marginTop: "30px",
                              color: "white",
                            }}
                          >
                            Change
                          </p>
                          <p
                            style={{
                              fontWeight: "600",
                              padding: "6px",
                              borderRadius: "8px",
                              backgroundColor: "#f73e4eff",
                              cursor: "pointer",
                              width: "fit-content",
                              marginTop: "30px",
                              color: "white",
                            }}
                            onClick={handleLogout}
                          >
                            Logout
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div
                style={{
                  padding: "50px",
                  paddingLeft: "100px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    display: "flex",
                    gap: "16px",
                    cursor: "pointer",
                  }}
                >
                  <span
                    onClick={() => setbookingType(1)}
                    style={{
                      padding: "6px",
                      borderRadius: "4px",
                      border: "0.3px solid grey",
                      color: bookingType === 1 ? "white" : "black",
                      backgroundColor: bookingType === 1 ? "#144c94" : "white",
                    }}
                  >
                    My Bookings
                  </span>
                  <span
                    onClick={() => setbookingType(2)}
                    style={{
                      padding: "6px",
                      borderRadius: "4px",
                      border: "0.3px solid grey",
                      color: bookingType === 2 ? "white" : "black",
                      backgroundColor: bookingType === 2 ? "#144c94" : "white",
                    }}
                  >
                    Cancellations
                  </span>{" "}
                </p>
                <div style={{ display: "flex", gap: "16px" }}>
                  <div
                    style={{
                      boxShadow: "0 4px 8px rgba(94, 36, 36, 0.2)",
                      width: "100%",
                      height: "100%",
                      borderRadius: "10px",
                      padding: "20px",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "18px",
                        fontWeight: "700",
                        padding: "10px",
                      }}
                    >
                      Previous Trips
                    </p>
                    {bookingType === 1 ? (
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          flexDirection: "column",
                          padding: "10px",
                          maxHeight: "70vh",
                          overflow: "auto",
                        }}
                      >
                        {history.map((deatil) => {
                          let d = deatil;
                          if (deatil.tripType === "roundTrip") {
                            d = deatil.bookings[0];
                          }
                          return (
                            <div
                              style={{
                                padding: "14px",
                                position: "relative",
                                boxShadow: "0px 0px 15px rgba(63, 24, 24, 0.4)",
                                display: "flex",
                                flexDirection: "column",
                                gap: "14px",
                                borderRadius: "10px",
                              }}
                            >
                              <p
                                style={{
                                  cursor: "pointer",
                                  position: "absolute",
                                  right: "6px",
                                  padding: "5px",
                                  borderRadius: "10px",
                                  backgroundColor: "#23b6aaff",
                                  color: "white",
                                }}
                                onClick={() => navigate("/ticket/" + d.id)}
                              >
                                View ticket
                              </p>
                              <img
                                src="/Assets/bus_10.png"
                                style={{ width: "45px" }}
                              />
                              <p
                                style={{ fontSize: "23px", fontWeight: "700" }}
                              >
                                {d.boardingPoint?.name}
                                <span
                                  style={{
                                    margin: "0px 20px",
                                    fontSize: "16px",
                                  }}
                                >
                                  {deatil.tripType === "roundTrip" ? (
                                    <img
                                      src="/Assets/switch.png"
                                      style={{ width: "20px" }}
                                    />
                                  ) : (
                                    <span> To </span>
                                  )}
                                </span>
                                {d.droppingPoint?.name}
                              </p>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <p
                                  style={{
                                    fontSize: "16px",
                                    fontWeight: "500",
                                  }}
                                >
                                  <img
                                    src="/Assets/date.png"
                                    style={{ width: "15px" }}
                                  />
                                  {new Date(
                                    d.journeyDetails?.date,
                                  ).toLocaleDateString()}
                                  {"  "}
                                </p>
                                <p
                                  style={{
                                    fontSize: "16px",
                                    fontWeight: "500",
                                    margin: "0px 20px",
                                  }}
                                >
                                  <span>
                                    <img
                                      src="/Assets/ticket-10.png"
                                      style={{ width: "15px" }}
                                    />{" "}
                                    {Number(d.pricing?.payableAmount).toFixed(
                                      2,
                                    )}{" "}
                                    /-
                                  </span>
                                  <span
                                    style={{
                                      borderRadius: "15px",
                                      padding: "4px",
                                      backgroundColor:
                                        d?.paymentStatus !== "success"
                                          ? "#666666ff"
                                          : "#33b966ff",
                                      color: "white",
                                    }}
                                  >
                                    {d.paymentStatus}
                                  </span>
                                </p>
                              </div>

                              <p
                                style={{
                                  borderBottom: "1px solid gray",
                                  fontSize: "17px",
                                  fontWeight: "600",
                                  color: "#1674aa",
                                }}
                              >
                                Passengers
                              </p>
                              {d?.seats?.map((i) => (
                                <p
                                  style={{
                                    padding: "8px",
                                    backgroundColor: "rgb(224, 222, 222)",
                                    borderRadius: "6px",
                                    margin: "4px",
                                  }}
                                >
                                  Seat No :
                                  <span style={{ fontWeight: "700" }}>
                                    {" "}
                                    {i.seatNumber}
                                  </span>
                                  <span
                                    style={{
                                      paddingLeft: "20px",
                                      fontSize: "17px",
                                      fontWeight: 700,
                                    }}
                                  >
                                    {i.passenger.name}({i.passenger.gender})
                                  </span>
                                  <span style={{ paddingLeft: "17px" }}>
                                    Seat Price : {i.fare}
                                  </span>
                                </p>
                              ))}

                              <p>
                                {" "}
                                Booking created At :
                                {new Date(deatil.createdAt).toLocaleString(
                                  "en-IN",
                                  {
                                    timeZone: "Asia/Kolkata",
                                  },
                                )}
                                {}
                              </p>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          flexDirection: "column",
                          padding: "10px",
                          maxHeight: "70vh",
                          overflow: "auto",
                        }}
                      >
                        {cancellations.map((deatil) => {
                          let d = deatil;
                          if (deatil.tripType === "roundTrip") {
                            d = deatil.bookings[0];
                          }
                          return (
                            <div
                              style={{
                                padding: "14px",
                                position: "relative",
                                boxShadow: "0px 0px 15px rgba(63, 24, 24, 0.4)",
                                display: "flex",
                                flexDirection: "column",
                                gap: "14px",
                                borderRadius: "10px",
                              }}
                            >
                              <p
                                style={{
                                  cursor: "pointer",
                                  position: "absolute",
                                  right: "6px",
                                  padding: "5px",
                                  borderRadius: "10px",
                                  backgroundColor: "#23b6aaff",
                                  color: "white",
                                }}
                                onClick={() => navigate("/ticket/" + d.id)}
                              >
                                View ticket
                              </p>
                              <img
                                src="/Assets/bus_10.png"
                                style={{ width: "45px" }}
                              />
                              <p
                                style={{ fontSize: "23px", fontWeight: "700" }}
                              >
                                {d.boardingPoint?.name}
                                <span
                                  style={{
                                    margin: "0px 20px",
                                    fontSize: "16px",
                                  }}
                                >
                                  {deatil.tripType === "roundTrip" ? (
                                    <img
                                      src="/Assets/switch.png"
                                      style={{ width: "20px" }}
                                    />
                                  ) : (
                                    <span> To </span>
                                  )}
                                </span>
                                {d.droppingPoint?.name}
                              </p>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <p
                                  style={{
                                    fontSize: "16px",
                                    fontWeight: "500",
                                  }}
                                >
                                  <img
                                    src="/Assets/date.png"
                                    style={{ width: "15px" }}
                                  />
                                  {new Date(
                                    d.journeyDetails?.date,
                                  ).toLocaleDateString()}
                                  {"  "}
                                </p>
                                <p
                                  style={{
                                    fontSize: "16px",
                                    fontWeight: "500",
                                    margin: "0px 20px",
                                  }}
                                >
                                  <span>
                                    <img
                                      src="/Assets/ticket-10.png"
                                      style={{ width: "15px" }}
                                    />{" "}
                                    {d.pricing?.payableAmount} /-
                                  </span>
                                  <span
                                    style={{
                                      borderRadius: "15px",
                                      padding: "4px",
                                      backgroundColor:
                                        d?.paymentStatus !== "success"
                                          ? "#666666ff"
                                          : "#33b966ff",
                                      color: "white",
                                    }}
                                  >
                                    {d.paymentStatus}
                                  </span>
                                </p>
                              </div>

                              <p
                                style={{
                                  borderBottom: "1px solid gray",
                                  fontSize: "17px",
                                  fontWeight: "600",
                                  color: "#1674aa",
                                }}
                              >
                                Passengers
                              </p>
                              {d?.seats?.map((i) => (
                                <p
                                  style={{
                                    padding: "8px",
                                    backgroundColor: "rgb(224, 222, 222)",
                                    borderRadius: "6px",
                                    margin: "4px",
                                  }}
                                >
                                  Seat No :
                                  <span style={{ fontWeight: "700" }}>
                                    {" "}
                                    {i.seatNumber}
                                  </span>
                                  <span
                                    style={{
                                      paddingLeft: "20px",
                                      fontSize: "17px",
                                      fontWeight: 700,
                                    }}
                                  >
                                    {i.passenger.name}({i.passenger.gender})
                                  </span>
                                  <span style={{ paddingLeft: "17px" }}>
                                    Seat Price : {i.fare}
                                  </span>
                                </p>
                              ))}

                              <p>
                                {" "}
                                Booking created At :
                                {new Date(deatil.createdAt).toLocaleString(
                                  "en-IN",
                                  {
                                    timeZone: "Asia/Kolkata",
                                  },
                                )}
                                {}
                              </p>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default MyProfile;
